module.exports = __webpack_public_path__ + "media/customizations/regencyattentrails/logo-d2c42160f4ccaaad586f539c5dccf212.png";